// Configuración de la aplicación React
const config = {
  // URL del API backend
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://recomiendate.tiendamax.com/api',
  
  // Configuración de la aplicación
  APP_NAME: 'RecomiendaT',
  APP_VERSION: '1.0.0',
  
  // Configuración de autenticación
  AUTH_TOKEN_KEY: 'authToken',
  AUTH_USER_KEY: 'authUser',
  
  // Configuración de la base de datos (solo para referencia)
  DATABASE: {
    HOST: '192.250.239.105',
    USER: 'owewazcn_admin',
    DATABASE: 'owewazcn_recomiendate',
    PORT: 3306
  }
};

export default config;
